import React from 'react';
import { HeroVariant22 } from '../components/HeroVariant22';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage22() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1525">
      <Navigation data-id="element-1526" />
      <main data-id="element-1527">
        <HeroVariant22 data-id="element-1528" />
        <WhyUs data-id="element-1529" />
        <Services data-id="element-1530" />
        <FAQ data-id="element-1531" />
        <Testimonials data-id="element-1532" />
        <Consultation data-id="element-1533" />
      </main>
      <Footer data-id="element-1534" />
      <CookieBanner data-id="element-1535" />
      <FloatingContact data-id="element-1536" />
    </div>;
}